module.exports = __webpack_public_path__ + "static/media/dark.0e4dd2f4.png";